<template>
  <div>

    <b-tabs pills card @input="acitveTab">
      <b-tab :title="$t('Active leases')">
        <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options"/>
        <basic-table
          v-if="dhcpLease"
          :items="dhcpLease"
          :fields="dhcpLeaseFields"
          :filter="filter"
          @ClickOnDeleteButton="ClickOnDeleteButton"
          @ClickOnEditButton="ClickOnExpireButton"
          :perPage="perPage"
          :currentPage="currentPage"
          :editImageProp="expireImage"
          :editExpireIcon="true"
          v-model="totalRows"
          isDelete="true"
          isEdit="true"/>
        <table-manager-bottom
          :totalRows="totalRows" :perPage="perPage"
          v-model="currentPage"/>
      </b-tab>

      <b-tab :title="$t('Expired leases')">
        <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options"/>
        <basic-table
          v-if="dhcpLease"
          :items="dhcpLeasesEpired"
          :fields="dhcpLeaseFields"
          :filter="filter"
          @ClickOnDeleteButton="ClickOnDeleteButton"
          @ClickOnEditButton="ClickOnExpireButton"
          :perPage="perPage"
          :currentPage="currentPage"
          v-model="totalRows"
          isDelete="true"
          />
        <table-manager-bottom
          :totalRows="totalRows" :perPage="perPage"
          v-model="currentPage"/>
      </b-tab>
    </b-tabs>

  </div>
</template>

<script>
export default {
  data () {
    return {
      expireImage: require('@/assets/img/expire2.png'),
      options: {
        isShowAddButton: false
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      poolsData: new Map(),
      dhcpLeaseFields: [
        {key: 'lease_id', label: 'ID', sortable: true},
        {key: 'ip', label: this.$i18n.t('IP'), sortable: true},
        {key: 'full_name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'mac', label: this.$i18n.t('MAC'), sortable: true},
        {key: 'server_id', label: this.$i18n.t('Server id'), sortable: true},
        {key: 'client_id', label: this.$i18n.t('Client id'), sortable: true},
        {key: 'expired', label: this.$i18n.t('Expired'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'updated', label: this.$i18n.t('Updated'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'flags_string', label: this.$i18n.t('Flags'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      static_lease: {flag: 0, name: 'static'},
      dynamic_active: {flag: 1, name: 'dynamic_active'},
      dynamic_incative: {flag: 2, name: 'dynamic_inactive'},
      modified_lease: {flag: 4, name: 'modified'},
      blocked_account: {flag: 8, name: 'blocked_account'}
    }
  },
  methods: {
    acitveTab (input) {
      if (input === 1) {
        this.loadExpired()
      }
    },
    loadExpired () {
      this.$store.dispatch('Inventory/GET_DHCP_LEASE_EXPIRED')
    },
    ClickOnExpireButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to expire lease?'), this.editItem, item)
    },
    async editItem (item) {
      let response = this.$store.dispatch('Inventory/EXPIRE_DHCP_LEASE', {lease_id: item.lease_id})
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 250, 'Inventory/GET_DHCP_LEASE_ACTIVE')
          setTimeout(this.$store.dispatch, 250, 'Inventory/GET_DHCP_LEASE_EXPIRED')
          this.$root.$emit('makeToasts', 'success', this.$i18n.t('Lease has been expired'))
          let index = this.dhcpLease.findIndex(element => element.lease_id === item.lease_id)
          this.dhcpLease[index]._rowVariant = 'danger'
        }
      })
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to drop that lease?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Inventory/DELETE_DHCP_LEASE', item.lease_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 250, 'Inventory/GET_DHCP_LEASE_ACTIVE')
          setTimeout(this.$store.dispatch, 250, 'Inventory/GET_DHCP_LEASE_EXPIRED')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    prepareLease (leases) {
      let nowTime = Math.round((new Date()).getTime() / 1000)
      for (let item of leases) {
        if (item.expired <= nowTime) {
          item._rowVariant = 'danger'
        }
        item.flags_string = '/'
        if (item.flags & this.static_lease.flag) item.flags_string += this.static_lease.name + '/'
        if (item.flags & this.dynamic_active.flag) item.flags_string += this.dynamic_active.name + '/'
        if (item.flags & this.dynamic_incative.flag) item.flags_string += this.dynamic_incative.name + '/'
        if (item.flags & this.modified_lease.flag) item.flags_string += this.modified_lease.name + '/'
        if (item.flags & this.blocked_account.flag) item.flags_string += this.blocked_account.name + '/'
      }
      return leases
    }
  },
  computed: {
    dhcpLease () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Inventory/DHCP_LEASE_ACTIVE']))
      return this.prepareLease(copy)
    },
    dhcpLeasesEpired () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Inventory/DHCP_LEASE_EXPIRED']))
      return this.prepareLease(copy)
    }

  },
  mounted () {
    this.$store.dispatch('Inventory/GET_DHCP_LEASE_ACTIVE')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/dhcpLease/main.vue